module["exports"] = ["福建省", "台灣省"];